import { measurableProduct } from './../../../core/configs/measurable-product.config';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ValidateInputService } from './../../../core';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-quantity',
  templateUrl: './quantity.component.html',
  styleUrls: ['./quantity.component.scss']
})
export class QuantityComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isMeasurable: string;
  @Input() id: string;
  @Input() typeCall: boolean;
  @Input() quantity: any;
  @Input() available: number;
  @Input() isTabla: boolean;
  @Input() isMaterial: boolean;
  @Input() disabled: number;
  @Output() update = new EventEmitter<number>();
  quantityControl: FormControl = new FormControl();
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(
    public validateService: ValidateInputService
  ) {
    /*  this.quantityControl = new FormControl('', [
       Validators.required,
       Validators.pattern('[0-9]{1,5}')
     ]); */
  }

  ngOnInit() {
    this.assignValidation();
    this.quantityControl.setValue(this.quantity ? this.quantity : 1);
    this.quantityControl.valueChanges
      .pipe(
        debounceTime(500),
        takeUntil(this.onDestroy$)
      )
      .subscribe(quantity => {
        const numericValue = Number(quantity); // Convertir a número
        if (
          this.quantityControl.valid &&
          this.available &&
          numericValue > parseInt(this.available.toString(), 10)
        ) {
          this.quantityControl.setValue(this.available);
        } else if (!isNaN(numericValue)) {
          this.update.emit(this.quantityControl.valid ? numericValue : 0); // Emitir como número
        }
        this.update.emit(numericValue !== 9999 ? numericValue : null); // Emitir null si es 9999
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    const numericValue = Number(this.quantity); // Convertir a número
    this.quantityControl.setValue(numericValue ? numericValue : 1);
    if (
      this.available &&
      numericValue > parseInt(this.available.toString(), 10)
    ) {
      this.quantityControl.setValue(this.available);
    }

    if (this.disabled) {
      this.quantityControl.disable({ onlySelf: false, emitEvent: false });
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  assignValidation() {
    const validators = [];

    if (this.isMeasurable === measurableProduct.isMeasurable) {
      validators.push(
        Validators.pattern('[0-9]{1,5}(?:[.][0-9]{1,3})?')
      );
    } else {
      validators.push(
        Validators.pattern('[0-9]{1,5}')
      );
    }

    if (this.isMaterial) {
      validators.push(Validators.required);
    }

    this.quantityControl.setValidators(validators);
    this.quantityControl.updateValueAndValidity();
  }

  add(): void {
    if (
      this.quantityControl.valid &&
      (!this.available ||
        (this.available &&
          parseInt(this.quantityControl.value, 0) < this.available))
    ) {
      this.quantityControl.setValue(
        parseInt(this.quantityControl.value, 0) + 1
      );
    }
  }

  remove(): void {
    if (
      this.quantityControl.valid &&
      parseInt(this.quantityControl.value, 0) > 1
    ) {
      this.quantityControl.setValue(
        parseInt(this.quantityControl.value, 0) - 1
      );
    }
  }

  defect(value): void {
    if (!Number(value.target.value)) {
      this.quantityControl.setValue(this.quantity);
    }
  }

  validateInput = event => {
    this.validateService.validateInput(event, this.isMeasurable);
  }
}
